var map = {
	"./base.js": "4576",
	"./combination.js": "29a9",
	"./dcwj.js": "1937",
	"./gradeHospital.js": "9ff6",
	"./index.js": "3908",
	"./jcyljg.js": "521a",
	"./makeScene.js": "0006",
	"./makeSceneTarget.js": "d855",
	"./otc.js": "5e75"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) { // check for number or string
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return id;
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "8d5a";